@if (activeMainItem()?.children?.length > 0) {
<bas-side-nav-hotlink
		[items]="activeMainItem().children"
		[topLevel]="true"
></bas-side-nav-hotlink>
}
